/**
 * ページ権限情報のキャッシュ
 * メモリ上に保持し、アプリケーション内で共有
 */
let permissionsCache = null;
/**
 * 権限情報をメモリに保存
 * @param permissions ページ権限リスト
 */
export const setPermissions = (permissions) => {
    permissionsCache = permissions;
    console.log('権限情報をメモリに保存しました:', permissions);
};
/**
 * メモリから権限情報を取得
 * @returns ページ権限リスト（未設定の場合は空配列）
 */
export const getPermissions = () => {
    return permissionsCache || [];
};
/**
 * 特定のpageIdに対する権限を取得
 * @param pageId ページID
 * @returns 権限情報（存在しない場合はundefined）
 */
export const getPermissionByPageId = (pageId) => {
    if (!permissionsCache) {
        return undefined;
    }
    return permissionsCache.find(p => p.pageId === pageId);
};
/**
 * 特定のpageIdが表示権限を持つかチェック
 * @param pageId ページID
 * @returns 表示可能かどうか（pageIdが取得されており、かつpermissionTypeが'0000'でない場合に表示）
 */
export const hasPermission = (pageId) => {
    const permission = getPermissionByPageId(pageId);
    return permission !== undefined && permission.permissionType !== '0000';
};
/**
 * 権限が読み込まれているかチェック
 * @returns 権限情報が存在するかどうか
 */
export const isPermissionsLoaded = () => {
    return permissionsCache !== null;
};
